import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ViewFullscreenIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M4.66665 9.33337H3.33331v3.33333h3.33334v-1.3333h-2V9.33337ZM3.33331 6.66671h1.33334v-2h2V3.33337H3.33331v3.33334Zm7.99999 4.66669H9.33331v1.3333h3.33329V9.33337h-1.3333v2.00003ZM9.33331 3.33337v1.33334h1.99999v2h1.3333V3.33337H9.33331Z" />
  </Icon>
);

export default memo(ViewFullscreenIcon);
